import React from 'react';
import joePortrait from './assets/joe-performing.jpg';
import './hitLabPaidOffer.css';
const decisions = {
  earned_next_move: 'Earned next move',
  not_yet: 'Not selected this time',
  hold_second_listen: 'Hold for a second listen',
};
export default function HitLabListenResult({
  result,
  editorial = false,
  catalogAvailable = false,
}) {
  if (!result) return null;
  return (
    <article
      className="listen-result"
      aria-label={
        editorial ? 'Example Listen Result' : 'Your released Listen Result'
      }
    >
      <header className="result-letterhead">
        <span className="footer-brand">JG HITLAB</span>
        <span>LISTEN RESULT</span>
      </header>
      <div className="result-record">
        {result.coverArtUrl && (
          <img
            className="result-art"
            src={result.coverArtUrl}
            alt={`${result.songTitle} artwork`}
          />
        )}
        <div>
          <p className="eyebrow">{result.artistName}</p>
          <h2>{result.songTitle}</h2>
          {editorial && (
            <p className="result-context">
              Example for a record already in rotation.
            </p>
          )}
        </div>
      </div>
      <div className="result-authorship">
        <div className="joe-portrait">
          <img src={joePortrait} alt="Joe Galaxy" />
        </div>
        <div>
          <span>Your reviewer</span>
          <strong>{result.reviewerName}</strong>
          <small>HitLab reviewer · JG Radio curator</small>
          {result.reviewedAt && (
            <small>
              Reviewed {new Date(result.reviewedAt).toLocaleDateString()}
            </small>
          )}
        </div>
      </div>
      {result.authoredFeedback && (
        <div className="feedback-body">
          {result.authoredFeedback.split('\n\n').map((text, index) => (
            <p key={index} style={{ whiteSpace: 'pre-wrap' }}>
              {text}
            </p>
          ))}
        </div>
      )}
      {!editorial && (
        <div className="result-findings">
          {[
            ['What stands out', result.strongestThing],
            ['What needs attention', result.mainLimiter],
            ['Joe’s assessment', result.oneSentenceTruth],
            ['Your next step', result.recommendedNextAction],
          ].map(
            ([title, content]) =>
              content && (
                <section key={title}>
                  <h3>{title}</h3>
                  <p>{content}</p>
                </section>
              ),
          )}
        </div>
      )}
      <footer className="result-outcome">
        <span>
          {editorial ? 'Current catalog status' : 'Selection decision'}
        </span>
        <strong>
          {editorial
            ? catalogAvailable
              ? 'In JG Radio rotation'
              : 'Not currently available in the catalog'
            : decisions[result.decision]}
        </strong>
        <p>
          {editorial
            ? 'Current availability may change.'
            : 'Payment covers your review. Radio rotation is earned.'}
        </p>
        {!editorial && (
          <p>Released {new Date(result.releasedAt).toLocaleString()}</p>
        )}
      </footer>
    </article>
  );
}
